import BaseModel from '../base/BaseModel.model';
export default class AnnoucementType extends BaseModel {

    public name: string;
    public code: string;

    constructor() {
        super();
        this.init();
    }

    init() {
        this.name = "";
        this.code = "";
    }
}